"use client";
import Hyperlink from "@/components/ui/hyperlink";
import { useModalContext } from "@/contexts/ModalContext";

import Image from "next/image";

interface HeroProps {
    title: string;
    description: string;
    btn1: string;
    btn2: string;
}

const Hero = ({ title, description, btn1, btn2 }: HeroProps) => {
    const modal = useModalContext();

    const handleModalOpen = (modalTitle?: string) => {
        modal.openModal(modalTitle);
    };
    return (
        <>
            <section
                className="desilo-hero2-section section-padding-bottom overflow-hidden"
                style={{ 
                    position: 'relative', 
                    background: '#FFF',
                    minHeight: '400px'
                }}
            >
                {/* LCP Optimized Background Image */}
                <Image
                    src="/images/hero/desilo.png"
                    alt=""
                    fill
                    priority
                    fetchPriority="high"
                    sizes="100vw"
                    style={{
                        objectFit: 'cover',
                        objectPosition: 'right center',
                        zIndex: 0,
                    }}
                />
                
                {/* Gradient Overlay */}
                <div style={{
                    position: 'absolute',
                    inset: 0,
                    background: 'linear-gradient(63deg, rgba(255, 212, 163, 0.4) 17.08%, rgba(255, 255, 255, 0.4) 83.17%)',
                    zIndex: 1,
                    pointerEvents: 'none'
                }} />

                <div className="container custom-container" style={{ position: 'relative', zIndex: 2 }}>
                    <div className="row g-4 justify-content-left">
                        <div className="col-lg-12 col-xxl-9">
                            <div className="desilo-hero-common__content desilo-hero5__info">
                                <h1 className="title" style={{ position: 'relative' }}>
                                    {title}
                                </h1>
                                <p className="hero2-content-text text-color-primary">
                                    {description}
                                </p>
                                {btn1 && btn2 && (
                                    <div className="d-md-flex d-block align-items-center gap-4">
                                        <Hyperlink
                                            href="https://calendly.com/parthik/30min"
                                            variant="primary"
                                            target="_blank"
                                        >
                                            {btn1}
                                        </Hyperlink>
                                        <Hyperlink
                                            variant="modal-pill"
                                            onModalOpen={handleModalOpen}
                                            modalTitle={btn2}
                                            className="text-color-primary d-block cursor-pointer"
                                        >
                                            {btn2}
                                        </Hyperlink>
                                    </div>
                                )}
                                {btn1 && !btn2 && (
                                    <Hyperlink
                                        href="https://calendly.com/parthik/30min"
                                        variant="primary"
                                        target="_blank"
                                    >
                                        {btn1}
                                    </Hyperlink>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        </>
    );
};

export default Hero;
